import React from "react";
import PropTypes from "prop-types";
import { getTextColor } from "../../../utils/utils";
import "./author-page-intro-card.m.css";

export const AuthorPageIntroductionCard = ({ config = {} }) => {
  const { pageTitle = "", pageDescription = "", theme } = config;
  const textColor = getTextColor(theme);

  const pageTitleData = pageTitle || "Our Authors";
  const pageDescriptionData =
    pageDescription ||
    "An easy and obvious description to explain the contents of the page below. Recommended to be 1-2 lines long.";

  return (
    <div
      styleName="author-page-wrapper"
      className="arrow-component full-width-with-padding"
      style={{ background: theme }}>
      <h2 styleName={`pageTitle ${textColor}`}>{pageTitleData}</h2>
      <div styleName={`pageDescription ${textColor}`}>{pageDescriptionData}</div>
    </div>
  );
};

AuthorPageIntroductionCard.propTypes = {
  config: PropTypes.shape({ theme: PropTypes.string, pageTitle: PropTypes.string, pageDescription: PropTypes.string })
};
